export default "__VITE_ASSET__Cbr04rjO__"